// Punto de entrada de panel-super-admin.
// Fase 4 — reemplaza el placeholder de Fase 1. Bootstrap de la SPA:
// inicializa sesión, registra rutas y arranca el router.

import { instalarErrorBoundary } from '@plataforma/utils';

instalarErrorBoundary({ prefijo: 'panel-super-admin' });

import '@plataforma/ui/src/estilos-base.css';
import '@plataforma/ui/src/estilos-layout.css';
import '@plataforma/ui/src/index.js';

import '../styles/main.css';

import {
  iniciarEnrutador,
  refrescarRuta,
  registrarRuta,
  registrarRutaNoEncontrada,
} from './enrutador.js';
import { inicializarSesion, suscribirseASesion } from './estado-sesion.js';
import { vistaActividad } from './vistas/actividad.js';
import { vistaAuditoria } from './vistas/auditoria.js';
import { vistaBeneficios } from './vistas/beneficios.js';
import { vistaCambiarContrasena } from './vistas/cambiar-contrasena.js';
import { vistaConfiguracion } from './vistas/configuracion.js';
import { vistaContrataciones } from './vistas/contrataciones.js';
import { vistaDashboard } from './vistas/dashboard.js';
import { vistaDominios } from './vistas/dominios.js';
import { vistaEmpresas } from './vistas/empresas.js';
import { vistaIngresos } from './vistas/ingresos.js';
import { vistaLogin } from './vistas/login.js';
import { vistaMiEmpresa } from './vistas/mi-empresa.js';
import { vistaPagos } from './vistas/pagos.js';
import { vistaPlanes } from './vistas/planes.js';
import { vistaPromociones } from './vistas/promociones.js';
import { vistaPublicaciones } from './vistas/publicaciones.js';
import { vistaSinPermiso } from './vistas/sin-permiso.js';
import { vistaSuscripciones } from './vistas/suscripciones.js';
import { vistaTrials } from './vistas/trials.js';
import { vistaUsuarios } from './vistas/usuarios.js';
import { vistaVimosOutbox } from './vistas/vimos-outbox.js';

registrarRuta('/login', vistaLogin);
registrarRuta('/cambiar-contrasena', vistaCambiarContrasena);
registrarRuta('/sin-permiso', vistaSinPermiso);
registrarRuta('/', vistaDashboard);
registrarRuta('/ingresos', vistaIngresos);
registrarRuta('/empresas', vistaEmpresas);
registrarRuta('/usuarios', vistaUsuarios);
registrarRuta('/planes', vistaPlanes);
registrarRuta('/suscripciones', vistaSuscripciones);
registrarRuta('/trials', vistaTrials);
registrarRuta('/pagos', vistaPagos);
registrarRuta('/beneficios', vistaBeneficios);
registrarRuta('/promociones', vistaPromociones);
registrarRuta('/dominios', vistaDominios);
registrarRuta('/publicaciones', vistaPublicaciones);
registrarRuta('/contrataciones', vistaContrataciones);
registrarRuta('/actividad', vistaActividad);
registrarRuta('/auditoria', vistaAuditoria);
registrarRuta('/configuracion', vistaConfiguracion);
registrarRuta('/vimos-outbox', vistaVimosOutbox);
registrarRuta('/mi-empresa', vistaMiEmpresa);
registrarRutaNoEncontrada((contenedor) => {
  contenedor.innerHTML = `
    <div class="pf-login">
      <div class="pf-tarjeta pf-login__tarjeta" style="text-align:center;">
        <h1 class="pf-login__titulo">404</h1>
        <p class="pf-texto-suave">Esta página no existe.</p>
        <a href="#/" class="pf-boton pf-boton--primario">Ir al dashboard</a>
      </div>
    </div>
  `;
});

async function iniciar() {
  const app = document.getElementById('app');

  await inicializarSesion();

  // Cada cambio de sesión (login, logout, expiración) re-renderiza la ruta
  // actual: así, por ejemplo, un logout desde el dashboard vuelve solo al
  // login sin necesidad de que cada vista escuche el evento por su cuenta.
  suscribirseASesion(() => refrescarRuta());

  iniciarEnrutador(app);
}

iniciar();
